import React from 'react';
import {
    ContactContainer,
    ContactWrapper,
    ContactH1,
    ContactP,
    FormWrapper,
    Iframe
} from './ContactUsElements';

const ContactUsComponent = () => {
    return (
        <ContactContainer>
            <ContactWrapper>
                <ContactH1>Business Enquiries</ContactH1>
                <ContactP>
                    We'd love to hear from you. Fill out the form below and we'll get back to you as soon as possible.
                </ContactP>
                <FormWrapper>
                    <Iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdHqk5r5glUbv4ScEsxt62wKp1NZTXbv43WO-fo0HkKDvPuvg/viewform?embedded=true" />
                </FormWrapper>
            </ContactWrapper>
        </ContactContainer>
    );
};

export default ContactUsComponent;
